import Platform from '../base';
import navigationKeys from './config/keys/navigation';
import remoteKeys from './config/keys/remote-keys';
import _ from 'lodash';
import storage from '../../helpers/storage';

class Hisense extends Platform {
  navigationKeys = navigationKeys;
  remoteKeys = remoteKeys;
  deviceInfo = {};

  initialize(opt) {
    super.initialize(opt);
  }

  exit = () => {
    window.close();
  };

  getFirmwareVersion() {
    try {
      return (window.Hisense_GetFirmWareVersion || _.noop)();
    } catch (e) {
      return Platform.prototype.getFirmwareVersion();
    }
  }
  // stub
  getModelYear() {
    return 1970;
  }

  getModelName() {
    try {
      let modelName = (window.Hisense_GetModelName || _.noop)();

      if (!modelName) {
        if (navigator.userAgent.indexOf('Opera TV') !== -1) {
          modelName = 'Opera TV Store';
        } else {
          var uagModelName = navigator.userAgent.match(/(Hisense;|Hisense,)(.*?)(;|,)/);
          if (uagModelName && uagModelName[2] && uagModelName[2].trim().length > 0) {
            modelName = uagModelName[2].trim();
          }
        }
      }
      return modelName;
    } catch (e) {
      return Platform.prototype.getModelName();
    }
  }

  getUID() {
    try {
      this.deviceInfo.DUID = (window.Hisense_GetDeviceID || _.noop)();
      if (!this.deviceInfo.DUID) {
        let duid = storage.get('duid');
        if (!duid) {
          duid = (
            Date.now().toString(36) +
            Math.random()
              .toString(36)
              .substr(2, 9)
          ).toUpperCase();
          storage.set('duid', duid);
        }
        this.deviceInfo.DUID = duid;
      }
      return this.deviceInfo.DUID;
    } catch (e) {
      return Platform.prototype.getUID();
    }
  }

  getDeviceType() {
    return super.getDeviceType();
  }

  getDeviceRegistrationType() {
    return 'Hisense Vidaa';
  }

  getPlatformVersion() {
    try {
      let platformName = null;

      let matches = navigator.userAgent.match(/(Hisense-)(.*?)($|\s)/);

      if (matches && matches[0] && matches[0].trim().length > 0) {
        platformName = matches[0].trim().replace('Hisense-', '');
      }
      return platformName || Platform.prototype.getPlatformVersion();
    } catch (e) {
      return Platform.prototype.getPlatformVersion();
    }
  }

  getBrand() {
    return 'Hisense';
  }

  getName() {
    return 'Hisense';
  }
}

export default Hisense;
